<template>
  <div :class="wrapperClasses">
    <div :class="classes" :style="barStyles" :title="percent"></div>
  </div>
</template>

<script>
  export default {
    name: 'consumption-bar',
    props: {
      extraClasses: {
        type: Array,
        default: () => [],
      },
      barClasses: {
        type: Array,
        default: () => [],
      },
      value: {
        // Between 0 and 1 for 0 tp 100%.
        type: Number,
        default: 0,
      },
    },
    computed: {
      wrapperClasses() {
        return ['consumption-bar', ...this.extraClasses]
      },
      classes() {
        let classes = ['consumption-bar__bar']
        if (this.barClasses.length) {
          classes = classes.concat(this.barClasses)
        }
        return classes.join(' ')
      },
      percent() {
        return (this.value * 100).toFixed(2) + '%'
      },
      barStyles() {
        return `width: ${this.percent};`
      },
    },
  }
</script>

<style lang="scss">
  .consumption-bar {
    flex-shrink: 0;
    flex-grow: 1;
    background: rgba(0, 0, 0, 0.03);
    margin-left: auto;
    max-width: 500px;
    margin-right: $spacer10;

    @media (max-width: $bp-ssm - 1px) {
      order: 3;
      width: 100%;
      margin-top: $spacer025;
      margin-bottom: $spacer10;
    }

    @media (min-width: $bp-ssm) {
      display: flex;
      justify-content: flex-start;
    }

    &__bar {
      height: 1rem;
    }
  }
</style>
